
export const isFeatureEnabled = (
    searchString: string,
    flagName: string,
    { variant }: { variant: string | null } = { variant: null },
) => {
    const searchParams = new URLSearchParams(searchString);
    return variant != null ? searchParams.get(flagName) === variant : searchParams.has(flagName);
};
